module.exports = __webpack_public_path__ + "img/flag_fr.a74138ae.svg";